import { useCallback } from 'react';
import { CareCreditCollectMultiStep, CareCreditCollectSubmissionStatus } from '@frontend/payments-care-credit';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { useUpdatePaidRequestPoll } from '../../../hooks/use-update-paid-request-poll';
import { PAYMENT_MULTI_STEP_LABELS, PAYMENT_MULTI_STEPS } from '../../../utils/steps';
import { StyledStep } from '../../atoms/styled-step';
import { CareCreditCollectStepBodyProps } from './care-credit-collect.types';

export const CareCreditCollectBody = ({
  onGoBack,
  onCancel,
  onSubmissionAccepted,
  onSubmissionDeclined,
  onGoToMessageStep,
}: CareCreditCollectStepBodyProps) => {
  const onComplete = useCallback(() => {
    onGoBack();
  }, [onGoBack]);

  const {
    person,
    invoice,
    careCreditData,
    activeLocationId,
    merchant,
    invoiceQuery: { refetch: refetchInvoiceQuery },
  } = useCollectPaymentMultiContext();

  const { setProcessingAndStartPoll } = useUpdatePaidRequestPoll(invoice, () => {
    // extra callback here when invoice updated
  });

  const onSubmissionComplete = useCallback(
    (status: CareCreditCollectSubmissionStatus) => {
      if (status === 'success') {
        onSubmissionAccepted();
        setProcessingAndStartPoll();
      } else if (status === 'declined') {
        onSubmissionDeclined();
      }
    },
    [onSubmissionAccepted, onSubmissionDeclined]
  );

  const onRefetchInvoice = useCallback(() => {
    return refetchInvoiceQuery().then((res) => res.data);
  }, [refetchInvoiceQuery]);

  return (
    <StyledStep
      id={PAYMENT_MULTI_STEPS.careCreditCollect}
      label={PAYMENT_MULTI_STEP_LABELS['care-credit-collect']}
      hasInternalFooter
      showBlueHeader
      hasChildStepper
      components={{
        Footer: () => null,
      }}
    >
      <CareCreditCollectMultiStep
        multiStepProps={{
          onComplete,
        }}
        merchant={merchant}
        locationId={activeLocationId}
        invoice={invoice}
        person={person}
        careCreditData={careCreditData}
        onCancel={onCancel}
        onGoBack={onGoBack}
        onGoToMessageStep={onGoToMessageStep}
        onSubmissionComplete={onSubmissionComplete}
        onRefetchInvoice={() => onRefetchInvoice()}
      />
    </StyledStep>
  );
};
